module.exports = __webpack_public_path__ + "static/media/TableCornerScratch_Before.c6f9a30c.jpg";